import React from 'react'
import ReactDOM from 'react-dom'

export const attachYmaps3React = async (res: typeof ymaps3) => {
  const [ymaps3React, ymaps3Controls, ymaps3Clusterer] = await Promise.all([
    res.import('@yandex/ymaps3-reactify'),
    res.import('@yandex/ymaps3-controls@0.0.1'),
    res.import('@yandex/ymaps3-clusterer@0.0.1'),
  ])

  const reactify = ymaps3React.reactify.bindTo(React, ReactDOM)
  const components = reactify.module(ymaps3)
  const controlsComponents = reactify.module(ymaps3Controls)
  const clustererComponents = reactify.module(ymaps3Clusterer)

  return {...components, ...controlsComponents, ...clustererComponents}
}
